'use strict'

/**
 * Provee las funcionalidades para refrescar automaticamente las páginas  web.
 */
class BodyRefresh
{
    /**
     * Constructor
     */
    constructor ()
    {
        this.timer = false
    }

    /**
     * Configura la acción para refrescar la página.
     */
    setup ()
    {
        let timeOutPeriod = parseInt(document.querySelector('body').getAttribute('data-time'));
        if (timeOutPeriod) {
            console.log('timer: ' + (timeOutPeriod / 1000) + 's');
            this.timerStart(timeOutPeriod);

            // Set globbal functions
            window.br = {
                start: () => {
                    this.timerStart(timeOutPeriod);
                },
                stop: this.timerStop
            };
        }
    }

    /**
     * Inicializa el timer para hacer el refresh de la página.
     *
     * @param timeOutPeriod
     * @returns {number}
     */
    timerStart (timeOutPeriod)
    {
        console.log('Page refresh start!');
        window.timer = setTimeout(function () {
            location.reload()
        }, timeOutPeriod)
    }

    /**
     * Finaliza el timer.
     */
    timerStop ()
    {
        console.log('Page refresh stopped!');
        clearTimeout(window.timer);
    }
}

export default new BodyRefresh();
